module.exports = __webpack_public_path__ + "img/intercom-app@3x.a3c33956.webp";